import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_INTEREST_ONLY_CHECK: MijnRoute = {
    path: 'hypotheken-aflossingsvrij',
    navigationEvent: 'toHypothekenAflossingsvrij',
    regex: /^\/hypotheek\/hypotheken-aflossingsvrij$/,
    webcomponent: 'mijn-hypotheken-aflossingsvrij-webcomponent'
};
